/* ─────────────────────────────────────────────────────────────
   SectionHeading — refined fintech style.
   Restrained micro-eyebrow (hairline rule + letterspaced label),
   large confident display title, optional gradient highlight.
───────────────────────────────────────────────────────────── */
export default function SectionHeading({
  eyebrow,
  title,
  highlight,
  description,
  centered = false,
  light = false,
}) {
  return (
    <div className={centered ? "text-center" : ""}>
      {eyebrow && (
        <div
          className={`mb-6 flex items-center gap-3 ${
            centered ? "justify-center" : ""
          }`}
        >
          <span
            className={`h-px w-8 ${
              light
                ? "bg-gradient-to-r from-transparent to-white/40"
                : "bg-gradient-to-r from-transparent to-[#4328E7]/35"
            }`}
          />
          <span
            className={`font-montserrat text-[10.5px] font-bold uppercase tracking-[0.3em] ${
              light ? "text-white/80" : "text-[#4328E7]"
            }`}
          >
            {eyebrow}
          </span>
          {centered && (
            <span
              className={`h-px w-8 ${
                light
                  ? "bg-gradient-to-l from-transparent to-white/40"
                  : "bg-gradient-to-l from-transparent to-[#4328E7]/35"
              }`}
            />
          )}
        </div>
      )}

      <h2
        className={`font-montserrat text-[2.4rem] font-black leading-[1.0] tracking-[-0.042em] sm:text-5xl lg:text-[3.65rem] ${
          light ? "text-white" : "text-[#0d0828]"
        }`}
      >
        {title}
        {highlight ? (
          <>
            <br />
            <span
              className={
                light
                  ? "bg-gradient-to-r from-white to-[#c9c5ff] bg-clip-text text-transparent"
                  : "bg-gradient-to-r from-[#4328E7] via-[#4328E7] to-[#6d63ff] bg-clip-text text-transparent"
              }
            >
              {highlight}
            </span>
          </>
        ) : null}
      </h2>

      {description ? (
        <p
          className={`mt-6 font-montserrat text-base leading-8 sm:text-lg ${
            centered ? "mx-auto max-w-2xl" : "max-w-xl"
          } ${light ? "text-white/70" : "text-[#0d0828]/60"}`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}
